import { getSupplierCode } from '@util';

// 初始化数据
const modals = {
  searchParams: {
    page: 1,
    size: 10,
    supplierCode: getSupplierCode(),
  },
  searchValue: {
    data: [],
    total: 0,
  },
  tableLoading: false,
};
export default modals;
